export interface FactAttributeDetail {
  label: string;
  value: string | null;
}

interface FactAttribute {
  attributeName: string;
  value: any;
  displayName?: string;
}

export const transformAttributeValue = (raw: string): string => {
  const bt = raw.match(/^bt_(\d+)\|(\d+)$/);
  if (bt) return `Between ${bt[1]} to ${parseInt(bt[2], 10) - 1}`;

  const single = raw.match(/^(lt|gt|le|ge)_(.+)$/);
  if (single) {
    const labels: Record<string, string> = {
      lt: 'Less than',
      gt: 'Greater than',
      le: 'Less than or equal to',
      ge: 'Greater than or equal to',
    };
    return `${labels[single[1]]} ${single[2]}`;
  }

  return raw;
};

export const extractFactAttributeDetails = (
  attributes: FactAttribute[] | null | undefined,
): FactAttributeDetail[] =>
  (attributes ?? [])
    .filter(attr => attr)
    .map(attr => ({
      label: attr.displayName ?? attr.attributeName,
      value:
        attr.value === null || attr.value === undefined
          ? null
          : transformAttributeValue(String(attr.value)),
    }));
